import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Cataloghi } from 'my-lib-sanfelici';
import { SlugService } from 'my-lib-sanfelici';
import { CataloghiService } from 'my-lib-sanfelici';

@Component({
  selector: 'app-cataloghi-create',
  templateUrl: './cataloghi-create.component.html',
  styleUrls: ['./cataloghi-create.component.css']
})
export class CataloghiCreateComponent implements OnInit {
    catalogo: Cataloghi ;
id:string;
  constructor(
    private slugservice:SlugService,
    private router: Router,
    private route: ActivatedRoute,
    private cataloghiservice: CataloghiService) { }
  submit() {
this.catalogo.slug = this.slugservice.slug(this.catalogo.id);

this.cataloghiservice.create(this.catalogo);

this.router.navigate(['/cataloghi']);
  }
  ngOnInit() {
    this.catalogo = {attivo: true, slug: null,id:null};
  }

}
